export default function FosWallet({color}) {
    console.log("COLOR RECEIVED --------> ", color)
//   const { color = "#84CAFF", fontSize = 24 } = sx;

  return (
    <svg
      width={25}
      height={25}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 7H3V5.5C3 4.67157 3.67157 4 4.5 4H17.5C18.3284 4 19 4.67157 19 5.5V7ZM3 9H21V18.5C21 19.3284 20.3284 20 19.5 20H4.5C3.67157 20 3 19.3284 3 18.5V9ZM16 13C15.4477 13 15 13.4477 15 14C15 14.5523 15.4477 15 16 15C16.5523 15 17 14.5523 17 14C17 13.4477 16.5523 13 16 13Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
